module.exports = __webpack_public_path__ + "static/media/acerta-logo.86aae5c5.svg";